import { CtaConfig } from "components/Tests/CallToOrder";
import { DIAGNOSTIC_ORDER_STATUS } from "graphql/types/globalTypes";
import { formatPrice } from "components/Juspay/helpers";

export const CORPORATE_EMAIL = "corporate@apollo247.org";

export const ConfigOneApolloData = {
  medicineCartString:
    "You will earn OneApollo Health Credits for this transaction, if applicable. T&C apply.",
  myMembershipBenefits: [
    {
      title: "Apollo Clinics",
      description: "Free home sample collections on clinic consultations",
      image: "apollo-clinics.jpg",
    },
    {
      title: "Apollo Cradle",
      description: "Avail 15% discount on Health Checks",
      image: "apollo-cradle.jpg",
    },
    {
      title: "Apollo Diagnostics",
      description:
        "Avail 5% discount on Lab & Imaging Services in OP Diagnostics",
      image: "apollo-diagnostics.jpg",
    },
  ],
  apolloHcsError: "Error occured while getting Patient OneApollo HCs",
};

export const CIRCLE_START_PRICE = `₹99`;

export const AVAILABILITY = "availability";
export const DISTANCE = "distance";
const PRICE_ASCENDING = "price_ascending";
const PRICE_DESCENDING = "price_descending";
const EXPERIENCE = "experience";

export const doctorListSortBy = [
  {
    sortBy: AVAILABILITY,
    name: "Availability",
  },
  {
    sortBy: DISTANCE,
    name: "Nearby",
  },
  {
    sortBy: PRICE_ASCENDING,
    name: "Price - low to high",
  },
  {
    sortBy: PRICE_DESCENDING,
    name: "Price - High to low",
  },
  {
    sortBy: EXPERIENCE,
    name: "Years of Experience",
  },
];

export const hospitalDoctorListSortBy = [
  {
    sortBy: AVAILABILITY,
    name: "Availability",
  },
  {
    sortBy: PRICE_ASCENDING,
    name: "Price - low to high",
  },
  {
    sortBy: PRICE_DESCENDING,
    name: "Price - High to low",
  },
  {
    sortBy: EXPERIENCE,
    name: "Years of Experience",
  },
];

export const jusPayConfiguration = {
  pollingtTimeInSecond: 5,
  paymentSuccessMsg:
    "Payment has already been processed for your booking. Kindly proceed to view details",
  paymentFailedMsg:
    "If any money is deducted, It will be refunded in 3-5 working days",
  upi: {
    validationMsg: "UPI ID not valid.",
    unknownIdMsg: "Something went wrong. Please try again.",
    timerHeading:
      "Open your UPI app to approve the payment request from Apollo 24|7",
    timeOutHeading1:
      "Please Approve the payment request before the time runs out !",
    timeOutHeading2: "Don’t press back until the transaction is complete",
    upiPaymentCancelMsg:
      "On cancelling the payment, the payment request will get cancelled only if you have not completed the payment on UPI Bank app.",
  },
  refunInitiatedMsg:
    'Your refund for amount "Rs {refundAmount}" has been initiated. It takes 4-5 working days for processing.',
  refundProcessedMsg: "Amount will be refunded within 5 to 7 working days",
  gPay: {
    timerHeading:
      "Open your Google Pay app to approve the payment request from Apollo 24|7",
    timeOutHeading1:
      "Please Approve the payment request before the time runs out !",
    timeOutHeading2: "Don’t press back until the transaction is complete",
    upiPaymentCancelMsg:
      "On cancelling the payment, the payment request will get cancelled only if you have not completed the payment on Google Pay app.",
  },
  paymentSuccess: "Your order has been placed successfully.",
  paymentPending:
    "We are taking longer than usual to confirm your order. Please check your order status after few minutes.",
};

export const SORT_OPTIONS = [
  AVAILABILITY,
  DISTANCE,
  PRICE_ASCENDING,
  PRICE_DESCENDING,
  EXPERIENCE,
];

export const diagnosticsSlotMessage = {
  heading: "Important message for items in your Cart:",
  message: `Sorry! We're working hard to get to this area! In the meantime, you can either pick up
	from a nearby store, or change the pincode.`,
  contactMessage:
    "You can also call 1860 500 0101 for Apollo Pharmacy retail customer care.",
};

export const conpatabilityMessage = {
  webCompatability:
    "This web browser is not supported for Audio/Video calls with doctor. For a seamless call with the doctor please switch to google chrome or download our mobile App!",
  mobileCompatability:
    "This mobile web browser is not supported for Audio/Video calls with doctor. For a seamless call with the doctor please download our mobile App!",
};

export const genericData = {
  consultDiffInMinutes: 15,
  consultEnableCancelTime: -30,
  defaultFollowUpChatDays: 7,
  defaultCategoryCount: 20,
  defaultSearchCount: 24,
  topSpecialties: [
    "Paediatrics",
    "General Physician/ Internal Medicine",
    "Dermatology",
    "Obstetrics & Gynaecology",
  ],
  defaultRadius: 20,
};
export const MAX_NUM_LINKS_PER_COLUMN_MEGA_MENU = 10;

// value in milliseconds
export const MEDICINE_SEARCH_DEBOUNCE_RATE = 500;

export const slickCdnUrls = {
  theme:
    "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css",
  css:
    "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css",
};
export const imageUrls = {
  consultOgImage: "https://www.apollo247.com/online-doctor-consultation.jpg",
  categoryOgImage: "https://www.apollo247.com/online-medicine.jpg",
};
export const localStoragePreserveKeys = ["isHealthByteTutorialShow"];
export const PRO_HEALTH_CONTACT = "1860-500-0707";
export const proHealthSuccessNextStepsHRA = {
  header:
    "Complete your health risk assessment in advance to save time during your visit",
  desc: `You are required NOT TO eat or drink atleast 8
  to 10 hours before the appointment. The entire
  process could take about 2 to 5 hours
  depending on your tests and consultations`,
};
export const SHOW_DISCOUNT = false;
export const discountText = {
  short: "40% Discount applied at hospital.",
  long: "40% Discount will be applied during payment at the hospital.",
};

export const DIAGNOSTICS_CATEGORY_TILES_CONFIG = {
  defaultMaxTilesInDesktop: 8,
  defaultMaxTilesInMobile: 8,
  defaultMaxRows: 2,
};

export const DEFAULT_CITY_NAME = "Hyderabad";
export const SOMETHING_WENT_WRONG = "Something went wrong!!";
export const SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN =
  "Something went wrong! Please try again.";
export const diagnosticWidgetTypes = {
  package: "Package",
  item: "Item",
  categoryScroll: "Category_Scroll",
  categoryGrid: "Category",
  banner: "Banner",
  list: "List",
  horizontalList: "horizontal_list",
  verticalList: "vertical_list",
};
export const widgetCardType = {
  package: "Package",
  test: "Test",
};
export const CATEGORY_SCROLL_MIN_LENGTH = 7;
export const TESTS_TO_SHOW = 6;
export const TESTS_TO_SHOW_IN_VERTICAL = 2;
export const PACKAGES_TO_SHOW = 3;
export const PACKAGES_TO_SHOW_IN_VERTICAL = 1;

export const DIAG_DIACARD_MODIFY_ORDER_MESSAGE = `You were trying to modify the order. Would you like to discard and go back to home page?`;
export const DIAGNOSTIC_DOCTOR_PRESCRIPTION = {
  HEADING1: "Item(s) added to your Cart",
  HEADING2: "Below item(s) are added in your cart: ",
  HEADING3: "Search for the remaining diagnostic tests and add to the cart.",
  UNAVAILABLE1: "item(s) in your prescription",
  UNAVAILABLE2:
    "Search for the diagnostic tests in your prescription and add to cart",
};

export enum DIAGNOSTIC_LATEST_ORDER_STATUS {
  LAB_TEST_BOOKING = "LAB TEST BOOKING",
  SAMPLE_SUBMITTED = "SAMPLES RECEIVED FOR TESTING!",
  REPORTS_READY = "REPORTS READY",
  PARTIAL_REPORT_READY = "PARTIAL REPORTS READY",
  SAMPLE_COLLECTED = "SAMPLE COLLECTED",
  PICKUP_REQUESTED = "HOME SAMPLE COLLECTION CONFIRMED!",
  PHLEBO_CHECK_IN = "APOLLO AGENT ON THE WAY!",
  PHLEBO_COMPLETED = "SAMPLE COLLECTION COMPLETED!",
  PARTIAL_ORDER_COMPLETED_BEFORE = "PARTIAL REPORTS GENERATED!",
  PARTIAL_ORDER_COMPLETED_AFTER = "PARTIAL REPORTS READY!",
  ORDER_COMPLETED = "REPORTS ARE READY!",
}
export enum DIAGNOSTIC_LATEST_ORDER_TRACK_STATUS {
  TRACK_APOLLO_AGENT = "TRACK APOLLO AGENT",
  CHECK_STATUS = "CHECK STATUS",
  VIEW_REPORT = "VIEW REPORT",
  TRACK_ORDER = "TRACK ORDER",
  RATE_APOLLO_AGENT = "RATE APOLLO AGENT",
  DOWNLOAD_INVOICE = "DOWNLOAD INVOICE",
  DOWNLOAD_REPORT = "DOWNLOAD REPORT",
}

export const DIAGNOSTIC_LATEST_ORDER_TRACK_CONTENT = {
  REPORTS_READY: `All your reports have been generated. You can view,
	download or share your reports.`,
  PARTIAL_REPORT_READY: `Partial reports have been generated. All reports will be generated by `,
  SAMPLE_SUBMITTED_BEFORE_TAT: `Samples are received in the lab for testing, and your invoice is generated. All test reports will be released before <tat>`,
  SAMPLE_SUBMITTED_AFTER_TAT: `Samples are received in the lab for testing, and your invoice is generated. Reports are getting delayed, but will be released soon.`,
  LAB_TEST_BOOKING: `Sample Collection appointment on`,
  PHLEBO_COMPLETED: `Our Apollo agent has successfully collected the samples`,
  PICKUP_REQUESTED:
    "Appointment for home sample collection scheduled on <date>",
  PHLEBO_CHECK_IN:
    "Apollo agent is on the way to your location for sample collection. Please share OTP <otp> after sample collection is completed.",
  PHLEBO_COMPLETED_BEFORE_TAT:
    "Sample collection completed. All test reports will be released before <tat>",
  PHLEBO_COMPLETED_AFTER_TAT:
    "Sample collection completed. Reports are getting delayed, but will be released soon.",
  PARTIAL_ORDER_COMPLETED_BEFORE_TAT:
    "Partial reports have been generated. Pending reports will be generated before <tat>",
  PARTIAL_ORDER_COMPLETED_AFTER_TAT:
    "Partial reports have been generated. Pending reports are getting delayed, but will be released soon.",
  ORDER_COMPLETED:
    "All your lab test reports have been generated. You can view, download or share your reports now.",
};

export const DIAGNOSTIC_STATUS_CARD_ICONS = {
  REPORTS_READY: "ic_medreport.png",
  LAB_TEST_BOOKING: "ic_testbooking.png",
  SAMPLE_SUBMITTED: "ic_sample.png",
  PARTIAL_REPORT_READY: "ic_medreport.png",
};

export const diagnosticPricingPackages = {
  all: "ALL",
  circle: "CIRCLE",
  special: "SPECIALDISCOUNTS",
};

export const diagnosticSplCouponName = "TESTS247";

export const quickBookCtaNumber = process.env.NEXT_PUBLIC_ASK_APOLLO_NUMBER;

export const DIAG_MODIFY_DUPLICATE_ITEM_MESSAGE =
  "{duplicateTests} and {higherPricesName} have common parameters, and cannot be booked together. Your cart would be updated.";
export const DIAG_ORDER_LIMIT = 5;
export const GENDER_DOB_MISSING_MESSAGE =
  "We are unable to confirm your order, since Gender and/or DoB is missing against this profile. Please contact customer care to get it updated.";
export const DIAGNOSTICS_ORDER_FAILED_MESSAGE =
  "We're sorry :(  There's been a problem with your booking. Please book again.";
export const DIAG_TESTS_DUPLICATE_MESSAGE = `The {duplicateTests} has been removed from your cart as it is already included in another test {higherPricesName} in your cart. Kindly proceed to pay the revised amount.`;
export const POPULAR_CITIES_CONSULTATION = {
  "New Delhi": "/doctors/doctors-in-new-delhi-dcity",
  Hyderabad: "/doctors/doctors-in-hyderabad-dcity",
  Chennai: "/doctors/doctors-in-chennai-dcity",
  Kolkata: "/doctors/doctors-in-kolkata-dcity",
  Mumbai: "/doctors/doctors-in-mumbai-dcity",
  Bangalore: "/doctors/doctors-in-bangalore-dcity",
  "All Cities": "/doctors",
};

export const selectPatientMessagesObj = {
  selectPatient1: "Who is the patient?",
  selectPatient2:
    "Make sure to add valid patient details, it will be reflected on Prescription and Invoice",
  selectPatientErrorMsg: "*Please select the patient before proceeding to pay!",
};

export const CTA_CONFIG: CtaConfig = {
  ctaDetailsOnCityId: [],
  ctaDetailsDefault: {
    ctaProductPageArray: ["HOME", "TESTLISTING", "TESTDETAIL"],
    ctaDelaySeconds: 3,
    ctaPhoneNumber: "040-4821-3322",
    ctaText: "Call to Order",
  },
  showHealthCreditsOnCartPage: false,
  cartWidgetCircleRibbonText: "",
  servicabilityTextConfig: {
    servicable: "",
    nonServicable: "",
    noLocation: "",
  },
  clevertapConfig: {
    logEvents: false,
  },
};

export const CTA_CONFIG_EXPIRY = 1 * 60 * 60 * 1000; // 1 hr
export const ITEM_CONFIG_EXPIRY = 12 * 60 * 60 * 1000; // 12 hrs
export const ORDER_CACHE_EXPIRY = 30 * 60 * 1000; // 30 mins
export const SLOT_CACHE_EXPIRY = 5 * 60 * 1000; // 5 mins
export const PHLEBOPOPUP_CONFIG_EXPIRY = 60 * 60 * 1000; // 1hr
export const RECENT_SEARCH_ITEM_COUNT = 2;
export const TOP_BOOKED_TESTS = "Top Booked Tests";
export const RADIOLOGY = "radiology";
export const MINIMUM_AGE_FOR_DIAGNOSTIC_ORDER = 10;
export const CIRCLE_PLAN_ID = "CIRCLEPlan";
export const ENABLE_DIAG_COUPON = true;
export const DIAG_NO_SEARCH_RESULT = {
  filterActive: `Sorry, we couldn’t find what you were looking for. Please reset the applied filters`,
  filterNotActive: `Sorry, we couldn’t find what you are looking for. Please check the recommendations below`,
};
export const DIAG_LANDING_PAGE_STATS = {
  cityCount: 40,
  collectionCentreCount: 1200,
};
export const DIAG_MAX_PATIENT_MESSAGE = (patientCount: number) =>
  `You can add selected tests for upto ${patientCount} patients`;
export const DIAG_TESTS_BOOKING_LIMIT = `Lab tests cannot be booked for below 10 years.`;
export const DIAGNOSTICS_NOT_SERVICEABLE_MESSAGE = `Sorry! We're working hard to get to this area! in the meantime, you can either visit clinic near your location or change the address`;
export const DIAGNOSTICS_SLOT_CONFIG = {
  Minutes: 60, // slots visible after this period for current date
  advanceBookingDaysNonCovid: 3, // slots can be booked upto this period for non covid tests
  advanceBookingDaysCovid: 3, // slots can be booked upto this period for covid tests
  Maxslot: "12:00", // 24 hours format
};
export const DIAG_APPOINTMENT_TIME_MESSAGE = (phleboETAString: string) =>
  `The sample collection executive will reach between ${phleboETAString} for collecting the samples.`;
export enum GROUP_PLAN {
  ALL = "ALL",
  CIRCLE = "CIRCLE",
  SPECIALDISCOUNTS = "SPECIALDISCOUNTS",
}
export const TOTAL_TEST_TEXT_CART = "Total Tests Included";
export const NO_SLOTS_TEXT = "No Slots Available";
export const SECOND_SEMPLE_PENDING = "2nd sample pending";
export const CIRCLE_PLAN_CONFIG_TEXT =
  "Get extra cashback and discounts on lab tests and medicine orders";
export const DIAG_CIRCLE_MEMBERSHIP_MESSAGES = {
  circle: {
    heading: "Yay! You are a Circle Member",
    upperLeftText: "You",
    isCircleAddedToCart: "Your effective price is",
    isCashbackAvailable: "Get additional cashback of",
  },
  nonCircle: {
    heading: "Buy Circle Membership",
    upperLeftText: "You can",
    isCircleAddedToCart: "Effective price would be",
    isCashbackAvailable: "Get additional cashback of",
  },
};
export const COULD_NOT_IDENTIFY_ADDRESS_MESSAGE = `Couldn't identify your address. Please update`;
export enum ADDADDRESS_TITLES {
  ADD_NEW_ADDRESS = "Add New Address",
  SET_LOCATION = "Set Location",
}
export const SEARCH_KEYWORD_LIMIT = 3;
export enum DETECT_LOCATION_STATUS {
  PROMT = "prompt",
  GRANTED = "granted",
  DENIED = "denied",
}
export const DIAG_TEST_RESPORT_MESSAGE = `Test reports will be generated by this name`;
export const TEST_FOR_MULTIPLE_USER =
  "All the tests must be for one person. Tests for multiple profiles will require separate purchases.";
export const PATIENT_GENDER = {
  M: "Male",
  F: "Female",
  B: "All",
};
export const GENDER_VALIDATION_TEXT = (gender: string) =>
  `This test can be added for ${gender} patient only.`;
export const DIAG_BANNER_VISIBILITY_ARRAY = ["both", "web"];
export const GENDER_APPLICABLE_MF_TEXT = (gender: string) =>
  `Tests in your cart are applicable for ${gender} patients only.`;
export const INCLUSION_VALIDATION_TEXT = `This test is already included in other items in your cart`;
export const DIAG_PASSPORT = {
  ADD_MESSAGE: "Add Passport Number to Your Report",
  EDIT_MESSAGE: "Passport Number Added to Your Report",
};

export const DIAGNOSTICS_ORDER_CANCEL_MESSAGE =
  "Your order has been cancelled successfully.";
export const ORDER_RESCHEDULE_MESSAGE =
  "Your Order has been rescheduled for selected time slot.";
export const DIAGNOSTICS_ORDER_RESCHEDULE_MESSAGE = `You have rescheduled thrice. You're out of reschedule attempts.`;
export const DIAGNOSTIC_STATUS_UPDATED_FROM_ITDOSE = `DIAGNOSTIC_STATUS_UPDATED_FROM_ITDOSE`;
export const ITDOSE_ORDERUPDATE_TEXT = `Canceled by Apollo agent as per the request`;
export const DIAG_TEST_RATING = {
  RATING_HEADING: "Rate your Experience with our Apollo agent",
  RATING_SUCCESS_MESSAGE: "We have received your rating successfully. Thanks",
  RATING_MAX_COUNT: 5,
  RATING_SHOW_COUNT: 4,
  RATING_RANGE: [
    {
      image: "reaction_terrible.png",
      title: "TERRIBLE",
      text: "Arrived very Late",
    },
    {
      image: "reaction_bad.png",
      title: "BAD",
      text: "Did not seem Well-Trained",
    },
    {
      image: "reaction_average.png",
      title: "AVERAGE",
      text: "Phlebo was not Polite",
    },
    {
      image: "reaction_good.png",
      title: "GOOD",
      text: "Didn’t Wear the PPE Kit or Gloves",
    },
    {
      image: "reaction_excellent.png",
      title: "EXCELLENT",
      text: "I have other Feedback",
    },
  ],
  RATING_POSITIVE_FEEDBACK: "I have Positive Feedback",
  RATING_EXPERIENCE_HEADING: "Rate your experience with our Phlebotomist",
  RATING_EXPERIENCE_SMALL: "Rate Phlebotomist",
  RATING_SUCCESS_HEADING:
    "You have successfully rated the Apollo Phlebotomist Experience",
  RATING_SUCCESS_POPUP_HEADING: "Thank you for your feedback",
};
export const DIAGNOSTIC_ORDER_CANCEL_TEXT = "Order was cancelled : ";
export const DIAGNOSTIC_EDIT_PROFILE_ARRAY = [
  DIAGNOSTIC_ORDER_STATUS.PICKUP_REQUESTED,
  DIAGNOSTIC_ORDER_STATUS.PICKUP_CONFIRMED,
];
export const TAT_BREACHED_MESSAGE =
  "Reports are delayed by a few hours, but should be available any time soon";
export const DIAG_TESTS_CANCEL_HEADING = `Why are you cancelling this order?`;
export const DEFAULT_REASON_TEXT = "choose any reason";
export const PREVENT_CANCELLATION = [
  {
    reason: "I am not available at location",
    text: "Do you want to Reschedule Appointment?",
    ctaText: "Reschedule Now",
    ctaActionKey: 1,
  },
  {
    reason: "Need to modify test details",
    text: "Do you want to add tests to your order?",
    ctaText: "Add Tests",
    ctaActionKey: 2,
  },
  {
    reason: "Need to modify patient details",
    text: "Do you want to edit patient details?",
    ctaText: "Edit Patient",
    ctaActionKey: 3,
  },
];

export const orderRecheduleObj = {
  rescheduleHeading1:
    "You can reschedule to a maximum of 3 times. If you click ok, you will have 2 reschedule attempt(s) left.",
  rescheduleHeading2: "Why are you rescheduling this order?",
};

export enum MODIFY_ORDER_TYPE {
  PREVIOUS = "PREVIOUS",
  CURRENT = "CURRENT",
}

export enum ORDER_MODIFY_STATUS {
  ORDER_MODIFIED = "Order Modified",
  ORDER_MODIFICATION = "Order Modification",
}

export const RESCHEDULE_MAX_COUNT = 3;
export const EDIT_PATIENT_GENDER_TEXT = (gender: string) =>
  `Tests in your order are applicable for ${gender} patients only.`;
export const PATIENT_SELECTION_TEXT = (itemType: string, gender: string) =>
  `${itemType} in your order are applicable for ${gender} patients only`;
export const ITEMS_GENDER_TYPE = {
  B: "B",
  M: "M",
  F: "F",
};

export const PAYMENT_STATUS_MESSAGE = {
  SUCCESS: (amountPaid: number) =>
    `Your order of ₹${formatPrice(amountPaid)} is placed`,
  PENDING:
    "We are checking with your bank. It can take upto 10 minutes to update your payment status",
  FAILURE: "If any money is deducted , It will be refunded in 3-5 working days",
};

export const MEDICINE_DELIVERY_NOTE =
  "   Seamlessly, order here your medicines and get deliveries in 2 hours. Also, same day home sample collection facility available for tests prescribed. T&C Apply.";
export const PREVIOUR_ORDER_ITEM_TEXT = {
  FREQUENCTLY_BOOKED_ITEMS: "frequently_booked",
  PREVIOUSLY_BOOKED_TESTS_AND_PACKAGES: "previously_booked",
};
export const RECOMMENDED_WIDGET_LIST = {
  URL_TITLE: "recommended-for-you-list",
  DISPLAY_TITLE: "RECOMMENDED FOR YOU",
};
export const SAMPLE_REJECTED_MESSAGE = {
  allItemsRejected: "Test samples have been rejected.",
  partialItemsRejected: "Test samples for few inclusions have been rejected.",
};
export const getBlockedItemText = (itemA: string, itemB: string) =>
  `${itemA} cannot be added along with ${itemB}`;
export const ACTIVE = "active";
export const DIAG_TYPE_FILTER = {
  PACKAGES: "Packages",
  TESTS: "Tests",
};
export const CATEGORY_WIDGET_TITLE = "POPULAR CATEGORIES";
export const PREPAID_CASHBACK_AMOUNT = 100;
export const DIAG_PRESCRIPTION_LIMIT = 3;
export const PREVIOUS_RECOMMENDED_DATA = 10;
export const DIAG_REFUND_MSG = {
  PREPAID_SUCCESS:
    "Refund initiated successfully. Amount should reflect in your account within 5-7 days.",
  PREPAID_FAILURE: "Refund request failed. Please try again in some time",
  OTHERS_SUCCESS:
    "Refund request received successfully. Refund amount will be initiated to your account within 5-7 days.",
  OTHERS_FAILURE: "Refund request failed. Please try again in some time",
};

export const CSAT_RATING = {
  RATING: [
    {
      image: "poor.png",
      image_submit: "poor_submit.png",
      title: "POOR",
    },
    {
      image: "okay.png",
      image_submit: "okay_submit.png",
      title: "OKAY",
    },
    {
      image: "good.png",
      image_submit: "good_submit.png",
      title: "GOOD",
    },
    {
      image: "great.png",
      image_submit: "great_submit.png",
      title: "GREAT",
    },
  ],
};

export const preVisitInstructions = [
  "Do not eat or drink anything other than water for 8-12 hours before the tests.",
  "Continue to take your usual medication. Carry previous medical records if any, prescriptions or medications.",
  "Please refrain from having alcohol or tobacco from the previous evening.",
  "Please wear comfortable clothes and slippers. In case a treadmill test is recommended, please carry a pair of walking or running shoes.",
  "Kindly inform at the reception desk if you have any history of diabetes.",
  "You will be offered a healthy breakfast once the blood tests are complete. The food will be the local cuisines depending on the culture of different local communities. You can contact the reception and ask for the breakfast.",
  "We advise pregnant women or women suspecting pregnancy not to undergo any X-Ray tests.",
  "It is recommended that women should stop using vaginal cream or foams 24 hours prior to the health check.",
  "A pap smear will not be taken from Women during their periods. Hence, its advisable to book this program after the menstrual cycle.",
];

export const preVisitEmail = "prohealth@apollohospitals.com";

export const preVisitTel = "1-860-500-0707";

export const PREV_ORDER_SECTION_NAME = {
  ITEMS: "Previously ordered items",
  RECOMMENDATIONS: "Previously ordered Recommendations",
};

export const PROHEALTH_DEFAULT_CITY =
  process.env.NEXT_PUBLIC_PRO_HEALTH_DEFAULT_CITY;

export enum CARD_TYPE {
  SHOW_EXPANDED = "show-expanded",
  SHOW_COLLAPSED = "show-collapsed",
  SHOW_INCLUSION = "show-inclusion",
}

export const LAB_TEST_FULL_WIDTH_TEST_COUNT = "8";
export const ITEMS_TAGS_TO_DISPLAY = 2;
export const CART_ITEMS_COUNT_TO_SHOW_PACKAGE_TEXT = 3;
export const hcWidgetConfig = {
  maxRedemptionPerc: 50,
  HcTitle: "Redeem Health Credits",
  HcAvailableTitle: "Available Health credits",
  getHcPriceBreakdownTitle: (perc: number) =>
    `Health Credits can be used to pay only ${perc}% of your order value`,
};
